module.exports = __webpack_public_path__ + "static/media/allianz-logo.1738789b.svg";